module.exports = __webpack_public_path__ + "img/small.220731fd.png";